import { ClaseModalidad } from './claseModalidad';
import { Pais } from './pais';

export class ClaseModalidadPais {
	id: string;
	claseModalidad: ClaseModalidad;
	paisIso3166a2: Pais;
	activo: boolean;

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.claseModalidad = new ClaseModalidad(data.claseModalidad);
			this.paisIso3166a2 = new Pais(data.pais);
			this.activo = data.activo;
		}
	}
}
